export default __webpack_public_path__ + "static/media/placeholder_dummy2016-massagestudio01-de.63b65321.png";